import React from "react";
import { Eye, Pencil, Monitor, Smartphone } from "lucide-react";

/**
 * EmailBuilderToggles — EMAILS-IMPL-015
 *
 * Builder|Preview and Desktop|Mobile segmented controls, matching the
 * Landing Page Builder's own interaction style: two real buttons (not
 * click-only divs, per the accessibility requirement), one active state.
 */
export function ModeToggle({ mode, onChange }) {
  return (
    <div className="flex items-center gap-1 rounded-full border border-white/10 bg-white/5 p-0.5" data-testid="builder-mode-toggle">
      <ToggleButton active={mode === "builder"} onClick={() => onChange("builder")} icon={Pencil} label="Builder" testId="builder-mode-builder" />
      <ToggleButton active={mode === "preview"} onClick={() => onChange("preview")} icon={Eye} label="Preview" testId="builder-mode-preview" />
    </div>
  );
}

export function DeviceToggle({ device, onChange }) {
  return (
    <div className="flex items-center gap-1 rounded-full border border-white/10 bg-white/5 p-0.5" data-testid="builder-device-toggle">
      <ToggleButton active={device === "desktop"} onClick={() => onChange("desktop")} icon={Monitor} label="Desktop" testId="builder-device-desktop" />
      <ToggleButton active={device === "mobile"} onClick={() => onChange("mobile")} icon={Smartphone} label="Mobile" testId="builder-device-mobile" />
    </div>
  );
}

function ToggleButton({ active, onClick, icon: Icon, label, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      data-testid={testId}
      className={
        "flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-colors " +
        (active ? "bg-violet-500/20 text-violet-200" : "text-slate-400 hover:text-slate-200")
      }
    >
      <Icon className="h-3.5 w-3.5" />
      {label}
    </button>
  );
}
